import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock, createVNode as _createVNode, withCtx as _withCtx, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-744555e2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "loginTabs" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", null, null, -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", null, null, -1))
const _hoisted_5 = {
  key: 1,
  class: "line"
}
const _hoisted_6 = { class: "tab-content" }
const _hoisted_7 = { key: 0 }
const _hoisted_8 = { key: 1 }
const _hoisted_9 = { class: "clause service" }
const _hoisted_10 = { class: "default-color" }
const _hoisted_11 = { class: "default-color" }
const _hoisted_12 = { class: "clause" }
const _hoisted_13 = {
  key: 1,
  class: "login-mask"
}

import VerufucaruibCode from "@/components/Login/VerificationCode/Index.vue";
import AcountNumber from "@/components/Login/AcountNumber/Index.vue";
import { ref, computed } from "vue";

import store from "@/store";
import { useRoute, useRouter } from "vue-router";


export default /*#__PURE__*/_defineComponent({
  __name: 'Index',
  setup(__props) {

const isShowLogin = computed(() => {
  return store.state.isLoginDialog || store.state.isMobile;
});

const num = ref(0);
const route = useRoute();
if (route.query.account) {
  num.value = 1;
}
const close = () => {
  store.commit("hideLogin");
};
const router = useRouter();
// 去注册
const handleRegister = () => {
  if (isMobile) {
    router.push({ name: "register" });
  } else {
    store.commit("showRegister");
    close();
  }
};
const isMobile = store.state.isMobile;

return (_ctx: any,_cache: any) => {
  const _component_Logo = _resolveComponent("Logo")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_unref(isShowLogin))
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: _normalizeClass(["login clearfix", { 'mobile-login': _unref(store).state.isMobile }])
        }, [
          (_unref(isMobile))
            ? (_openBlock(), _createBlock(_component_Logo, { key: 0 }))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_1, [
            (!_unref(isMobile))
              ? (_openBlock(), _createElementBlock("ul", _hoisted_2, [
                  _createElementVNode("li", {
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (num.value = 0)),
                    class: _normalizeClass({ active: num.value == 0 })
                  }, [
                    _createTextVNode(_toDisplayString(_ctx.$t("login.sign_with_code")), 1),
                    _hoisted_3
                  ], 2),
                  _createElementVNode("li", {
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (num.value = 1)),
                    class: _normalizeClass({ active: num.value == 1 })
                  }, [
                    _createTextVNode(_toDisplayString(_ctx.$t("login.sign_in")), 1),
                    _hoisted_4
                  ], 2)
                ]))
              : _createCommentVNode("", true),
            (!_unref(isMobile))
              ? (_openBlock(), _createElementBlock("div", _hoisted_5))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_6, [
              (num.value == 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                    _createVNode(VerufucaruibCode, {
                      onHandleAccount: _cache[2] || (_cache[2] = ($event: any) => (num.value = 1))
                    })
                  ]))
                : _createCommentVNode("", true),
              (num.value == 1)
                ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                    _createVNode(AcountNumber, {
                      onHandleAccount: _cache[3] || (_cache[3] = ($event: any) => (num.value = 0))
                    })
                  ]))
                : _createCommentVNode("", true)
            ])
          ]),
          _createElementVNode("div", _hoisted_9, [
            _createTextVNode(_toDisplayString(_ctx.$t("login.you_agree_to")) + " ", 1),
            _createVNode(_component_router_link, {
              target: "_blank",
              to: { path: '/user-privacy' }
            }, {
              default: _withCtx(() => [
                _createElementVNode("span", _hoisted_10, _toDisplayString(_ctx.$t("login.user_privacy")), 1)
              ]),
              _: 1
            }),
            _createTextVNode(" " + _toDisplayString(_ctx.$t("login.and")), 1),
            _createVNode(_component_router_link, {
              target: "_blank",
              to: { path: '/service-clause' }
            }, {
              default: _withCtx(() => [
                _createElementVNode("span", _hoisted_11, _toDisplayString(_ctx.$t("login.terms_of_service1")), 1)
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_12, [
            _createElementVNode("span", { onClick: handleRegister }, _toDisplayString(_ctx.$t("login.sign_up")), 1)
          ]),
          (!_unref(isMobile))
            ? (_openBlock(), _createElementBlock("div", {
                key: 1,
                class: "close",
                onClick: close
              }))
            : _createCommentVNode("", true)
        ], 2))
      : _createCommentVNode("", true),
    (_unref(store).state.isLoginDialog)
      ? (_openBlock(), _createElementBlock("div", _hoisted_13))
      : _createCommentVNode("", true)
  ], 64))
}
}

})